export const PUBLIC_ACTIVIST_LIMIT = 30;

export function normalizeActivistName(name) {
  return String(name || '').replace(/<[^>]*>/g, '').trim();
}

export function isPublicActivistName(name, publicActivistNames) {
  const normalized = normalizeActivistName(name);
  return publicActivistNames.some((candidate) => candidate === normalized);
}

export function selectPublicActivists(activists, limit = PUBLIC_ACTIVIST_LIMIT) {
  return activists.slice(0, limit);
}
